module.exports = __webpack_public_path__ + "media/images/icons/SVG/047-a21c717ded3404809dee01d1e0e5eded.svg";